/**
 * Whether the consent prompt's buttons get the TCF treatment, which is
 * reserved for the banner display style on websites configured for TCF.
 *
 * @param {Object} args
 * @param {String} [args.displayStyle]
 * @param {Object} [args.gvl] - the Global Vendor List, present only for TCF
 *
 * @returns {Boolean}
 */
export default function shouldShowTCFButtons({ displayStyle, gvl }) {
  return Boolean(gvl) && displayStyle === 'banner'
}
